import { Component, EventEmitter, Output} from '@angular/core';
import { ClickHistorySubject } from 'src/app/events/click-history.events';
import { SearchLogClickHistoryModel } from 'src/app/models/search-log-click-history.model';

@Component({
  selector: 'app-good-tracking',
  templateUrl: './good-tracking.component.html',
  styleUrls: ['./good-tracking.component.scss']
})
export class GoodTrackingComponent {

    selectedTab: 'air' | 'sea' = 'air';
    searchText: string = '';
    selectedOperationPlaceholder = 'airHawbOrRefNo';
    @Output() onSearch: EventEmitter<any> = new EventEmitter();

    onTabChange(tab: 'air' | 'sea') {
      this.selectedTab = tab;
      this.selectedOperationPlaceholder = tab == 'air'? 'airHawbOrRefNo': 'containerNoOrGoodRef'; 

      // onchange event → içi boş bırakıldı
      // burada sadece selectedTab güncelleniyor
    }



    onClickSearch() {
      if(!this.searchText) return;
      const model = new SearchLogClickHistoryModel();
      model.viewType = "T&T";
      model.productName = 'main-left';
      model.info =  this.searchText
      model.costType = this.selectedTab;
      ClickHistorySubject.next(model);

      this.onSearch.emit({searchText: this.searchText, operation: this.selectedTab});
    }
    constructor( ) {


    }


}
